var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"settings-channels"},[_c('h1',[_vm._v("Profile")]),_c('Profile'),_c('hr'),_c('h1',[_vm._v("Notifications")]),_c('TokensSettings'),_c('TokensCollection')],1)}
var staticRenderFns = []

export { render, staticRenderFns }